export const PROGRESS_FEATURE_KEY = 'progress';
